module.exports = __webpack_public_path__ + "static/CERN-38115a46a73a730c0a19b0c80e25fccd.png";